<script lang="ts" setup generic="T extends Object">
import { MInputGroup } from '#components'
import { ElInput, ElInputNumber, ElRadioGroup, ElSelect } from 'element-plus'

const compMap: Record<FormCompName, Component> = {
  'input': ElInput,
  'input-group': MInputGroup,
  'number': ElInputNumber,
  'select': ElSelect,
  'radio': ElRadioGroup,
  'picker': ElInput,
  'date': ElInput,
  'date-range': ElInput,
}

const props = defineProps<{
  model: T,
  formRef: any
  items: FormItem[],
  rules?: any,
  itemProps?: any
}>()

const formRef = ref()

onMounted(() => {
  props.formRef.validate = formRef.value.validate
})

</script>

<template>
  <el-form :rules="rules" :model="model" ref="formRef" v-bind="$attrs">
    <template v-for="v in items">
      <el-form-item :label="v.label" :required="v.required" :prop="v.name">
        <slot v-if="v.slotName" :name="v.slotName" v-bind="{ model, formItem: v }"></slot>
        <component v-else :is="compMap[v.comp ?? 'input']" v-model="model[v.name]" v-bind="v.props">
          <template v-if="v.comp === 'select'">
            <el-option v-for="o in v.options" :value="o.value" :label="o.label ?? o.value"></el-option>
          </template>
          <template v-if="v.comp === 'radio'">
            <el-radio v-for="o in v.options" :value="o.value">{{ o.label ?? o.value }}</el-radio>
          </template>
        </component>
      </el-form-item>
    </template>
    <slot></slot>
  </el-form>
</template>

<style lang="scss" scoped>
// label和input分行情况下的样式
:deep(.el-form-item) {
  flex-direction: column;
  margin-bottom: 0px;

  .el-form-item__label {
    padding: 0;
    margin-bottom: 8px;
  }

  .el-input {
    width: 100%;

    .el-input__wrapper {
      border: none;
      padding: 0;
      box-shadow: none;
      border-radius: 0;
    }

    input {
      width: 100%;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45) inset;
      padding: 9px 1rem;
      height: 40px;
      font-size: 14px;
      line-height: 22px;
    }
  }

  .el-select__wrapper {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45) inset;
    border-radius: 0;
    padding: 9px 1rem;
    height: 40px;
  }
}
</style>
